import React from "react";
import "./Chips.css";

/* Unit color is derived from the unit name itself (no new data field) —
   Corporate Office = blue, Branch Office = purple, Warehouse = amber,
   IT / Server Room = indigo, anything else = neutral gray. */
const UNIT_VARIANTS = [
  { test: /corporate/i, family: "chip-blue", icon: "fa-building" },
  { test: /branch/i, family: "chip-purple", icon: "fa-code-branch" },
  { test: /warehouse/i, family: "chip-warning", icon: "fa-warehouse" },
  { test: /\b(it|server)\b/i, family: "chip-indigo", icon: "fa-server" },
];

function getUnitVariant(name) {
  const value = String(name || "");
  const match = UNIT_VARIANTS.find((entry) => entry.test.test(value));
  return match || { family: "chip-neutral", icon: "fa-building" };
}

export default function UnitChip({ name }) {
  const label = name || "-";
  const { family, icon } = getUnitVariant(label);

  return (
    <span className={`chip ${family}`} title={label}>
      <i className={`fa-solid ${icon}`} aria-hidden="true"></i>
      <span className="chip-label">{label}</span>
    </span>
  );
}
